import { NavLink, useNavigate } from 'react-router-dom';
import { useState, useEffect }  from 'react';
import { useAuth }              from '../context/AuthContext';
import { useCompany }           from '../hooks/useCompany';
import { authFetch }            from '../utils/api';
import './NavBar.css';

function NavBar() {
  const { logout, user }             = useAuth();
  const { companyName }              = useCompany();
  const [qbStatus,  setQbStatus]     = useState('checking');
  const [menuOpen,  setMenuOpen]     = useState(false);
  const navigate                     = useNavigate();

  useEffect(() => {
    authFetch('/api/health')
      .then(r => r.json())
      .then(data => {
        const ok = data.checks?.qbToken?.status === 'ok';
        setQbStatus(ok ? 'connected' : 'error');
      })
      .catch(() => setQbStatus('error'));
  }, []);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  const dot = {
    connected: { color: '#15803D', label: 'QB Connected' },
    error:     { color: '#BE123C', label: 'QB Error' },
    checking:  { color: '#B45309', label: 'Checking...' },
  }[qbStatus];

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <span className="brand-name">ACCT4CAST</span>
        <span className="brand-sub">QuickBooks-FP&amp;A</span>
        {companyName && (
          <span className="brand-company">
            | {companyName}
            <span style={{
              marginLeft:   '0.75rem',
              background:   '#0E7C7B',
              color:        '#fff',
              borderRadius: 4,
              padding:      '0.1rem 0.4rem',
              fontSize:     '0.7rem',
              fontWeight:   700,
              letterSpacing:'0.05em',
            }}>
              FY{new Date().getFullYear()}
            </span>
          </span>
        )}
      </div>

      {/* Hamburger menu for mobile */}
      <button
        className="nav-hamburger"
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Toggle menu"
        style={{
          display:    'none',
          background: 'none',
          border:     'none',
          color:      '#fff',
          fontSize:   '1.5rem',
          cursor:     'pointer',
          padding:    '0.25rem 0.5rem',
        }}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      <div className={`navbar-links ${menuOpen ? 'nav-open' : ''}`}>
        <NavLink to="/"         end className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Dashboard</NavLink>
        <NavLink to="/bva"          className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Budget vs Actual</NavLink>
        <NavLink to="/forecast"     className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Forecast</NavLink>
        <NavLink to="/alerts"       className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Alerts</NavLink>
        <NavLink to="/sandbox"      className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Sandbox</NavLink>
        <NavLink to="/status"       className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Status</NavLink>
        {user?.role === 'admin' && (
          <NavLink to="/admin"      className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Admin</NavLink>
        )}
        <NavLink to="/profile"      className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Profile</NavLink>
      </div>

      <div className="navbar-status" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <span className="status-dot" style={{ backgroundColor: dot.color }} />
        <span className="status-label">{dot.label}</span>

        {/* Logout */}
        <button
          onClick={handleLogout}
          style={{
            background:   'transparent',
            border:       '1px solid #7A90B8',
            borderRadius: '6px',
            color:        '#7A90B8',
            padding:      '4px 12px',
            fontSize:     '0.8rem',
            cursor:       'pointer',
            marginLeft:   '8px',
          }}
        >
          {user?.email ? `Sign out` : 'Sign out'}
        </button>
      </div>
    </nav>
  );
}

export default NavBar;